import axios from "axios";
import { API } from "./api";

// Separate axios instance for customer-facing routes.
// - Includes credentials (cookie auth for Google OAuth sessions).
// - Sends Bearer token (email/password sessions) when set.
export const customerApi = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
});

export function setCustomerAuthToken(token) {
    if (token) {
        customerApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
        delete customerApi.defaults.headers.common["Authorization"];
    }
}
